import React from 'react';
import { useIntl } from 'react-intl';
import addDays from 'date-fns/addDays';
import { FixedDateRangePicker, Link, Popover, Span } from 'localmed-core';

import Calendar from '../../legacyCore/icons/Calendar';
import formatDateRange from '../utils/formatDateRange';
import { toDateNonNullable } from '../utils/toDate';

export default function CalendarDateChangePopup(props) {
  const intl = useIntl();
  const { selectedDate, minDate, onChangeSelectedDate } = props;
  const endDate = addDays(toDateNonNullable(selectedDate), 6);

  return (
    <Popover
      id="change-calendar-date"
      content={({ close }) => (
        <FixedDateRangePicker
          display="block"
          border="0"
          selectedRange={{ from: toDateNonNullable(selectedDate), to: endDate }}
          month={selectedDate}
          disabledDays={{ before: minDate }}
          fromMonth={minDate}
          todayButton="Today"
          onChange={(range) => {
            close();
            onChangeSelectedDate(range && range.from);
          }}
        />
      )}
    >
      <Link>
        <Span color="text" marginRight="sm">
          {formatDateRange(intl, selectedDate, endDate)}
        </Span>
        <Span className="text-nowrap">
          Change Date <Calendar />
        </Span>
      </Link>
    </Popover>
  );
}
